import { Box, List, ListItem, Typography } from "@mui/material";

type ListItemsProps = {
  title: string;
  items: string[];
};

export const ListItems = (props: ListItemsProps) => {
  return (
    <Box>
      <Typography
        variant="h6"
        sx={{
          marginTop: "1.25rem",
          textAlign: "left",
          lineHeight: "1.75rem",
        }}
      >
        {props.title}:
      </Typography>
      <List
        sx={{
          listStyleType: "disc",
          listStylePosition: "inside",
          paddingLeft: "1.25rem",
        }}
      >
        {props.items.map((item, index) => (
          <ListItem
            key={index}
            dense
            sx={{
              typography: (theme) => theme.typography.body1,
              display: "list-item",
              paddingX: 0,
              paddingY: "0.25rem",
              lineHeight: "1.75rem",
            }}
          >
            {item}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
